export default {
  app: {
    languagePopup: {
      title: 'Sie befinden sich derzeit auf der englischen Version von {logo}',
      subtitle: 'Möchten Sie zu Ihrer bevorzugten Sprache wechseln?',
      cta: 'Wechseln zu {lang}',
    },
  },
};
